import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 40px 1fr;
	align-items: flex-end;
	gap: 10px;
`;

const StyledIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 7px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	justify-content: space-between;

	${Text} {
		&:nth-child(1) {
			font-weight: 400;
			font-size: 14px;
			line-height: 16px;
			color: #ffffff;
			opacity: 0.5;
		}

		&:nth-child(2) {
			font-weight: 700;
			font-size: 14px;
			line-height: 16px;
			color: #ffffff;
		}
	}
`;

const StyledProgressContainer = styled.div`
	position: relative;
	width: 100%;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
`;

const StyledProgressWrapper = styled.div`
	position: absolute;
	top: 2px;
	left: 2px;
	right: 2px;
	bottom: 2px;
`;

const StyledProgress = styled.div`
	height: 14px;
	border-radius: 2px;
	transition: background-color 0.3s ease;
`;

export {
	StyledContainer,
	StyledIconContainer,
	StyledInfoContainer,
	StyledProgress,
	StyledProgressContainer,
	StyledProgressWrapper,
	StyledTopContainer,
};
